export function item(state, data) {
  state.item = data
}

export function items(state, data) {
  state.items = data
}

export function filterModulesItems(state, data) {
  state.filterModulesItems = data
}


export function productsItems(state, data) {
  state.productsItems = data
}

export function pagination(state, data) {
  state.pagination = data
}
